import {subMenuData, menuData} from "./menuData";

const kuhniVersoMenuNameOverrides = {
    myOrders: "Заказы на распил",
    mySamples: "Шаблоны деталей",
};

export const determineAccessibility = (userRoles, isUpMe, isKuhniVersoMebel = false) => {
    const excludedMenuTypes = isUpMe ? [] : ["systemSamples"];
    if (isKuhniVersoMebel) {
        excludedMenuTypes.push("production", "customer-production");
    }
    const subMenu = subMenuData.filter(menu => userRoles?.some(role => menu.roles.includes(role.name)))
    const menu = menuData
        .filter(menu => userRoles?.some(role => menu.roles.includes(role.name)) && !excludedMenuTypes.includes(menu.type))
        .map((menu) => ({
            ...menu,
            name: isKuhniVersoMebel && kuhniVersoMenuNameOverrides[menu.type]
                ? kuhniVersoMenuNameOverrides[menu.type]
                : menu.name,
        }))

    return {menu: menu, subMenu: subMenu}
}
